export const AwaitingApproved = ({ color = '#363BC4', size = 9 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size * 13) / 9}
    fill="none"
    viewBox="0 0 9 13"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.114 9.721h3.172M1.846 1h5.708c.296 0 .444 0 .557.058.1.05.18.131.231.23.058.114.058.262.058.558v1.096c0 .259 0 .388-.03.51a1 1 0 0 1-.126.305c-.065.107-.157.198-.34.381l-1.549 1.55c-.21.209-.314.314-.353.434a.53.53 0 0 0 0 .327c.04.12.144.225.353.435l1.55 1.55c.182.182.274.273.34.38q.086.143.126.306c.029.121.029.25.029.51v1.096c0 .296 0 .444-.058.557-.05.1-.131.18-.23.23-.114.058-.262.058-.558.058H1.846c-.296 0-.444 0-.557-.057a.53.53 0 0 1-.231-.231C1 11.17 1 11.022 1 10.726V9.629c0-.258 0-.388.03-.51q.038-.162.126-.305c.065-.107.157-.198.34-.38l1.549-1.55c.21-.21.314-.314.353-.435a.53.53 0 0 0 0-.327c-.04-.12-.144-.225-.353-.434l-1.55-1.55c-.182-.183-.274-.274-.34-.38a1 1 0 0 1-.126-.306C1 3.33 1 3.2 1 2.942V1.846c0-.296 0-.444.058-.557.05-.1.131-.18.23-.231C1.403 1 1.55 1 1.847 1"
    />
  </svg>
);
